






















































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import BaseComponent from '../../../core/base.component';
import { BaseUser } from '@/services/shared/auth';
import {
  FOUNDER_CONSULT,
  CONST_FOUNDER_CONSULT,
  GENDER,
  CONST_GENDER,
  PaginationCount,
  CONST_PAGINATION_COUNT,
} from '../../../services/shared';
import { CodeManagementDto } from '../../../services/init/dto';

import AdminService from '../../../services/admin.service';
import CompanyService from '../../../services/company.service';
import CompanyUserService from '../../../services/company-user.service';
import CompanyDistrictService from '../../../services/company-district.service';
import CodeManagementService from '../../../services/code-management.service';
import DeliveryFounderConsultService from '../../../services/delivery-founder-consult.service';
import DeliverySpaceService from '@/services/delivery-space.service';
import FoodCategoryService from '../../../services/food-category.service';
import SpaceTypeService from '../../../services/space-type.service';

import DeliveryFounderConsultNanudaUserList from './DeliveryFounderConsultNanudaUserList.vue';

import toast from '../../../../resources/assets/js/services/toast.js';

import { getStatusColor } from '../../../core/utils/status-color.util';

import {
  AdminDto,
  CompanyDto,
  CompanyUserDto,
  CompanyDistrictDto,
  DeliveryFounderConsultDto,
  DeliveryFounderConsultListDto,
  DeliverySpaceDto,
  FoodCategoryDto,
  NanudaUserDto,
} from '../../../dto';
import {
  Pagination,
  CONST_OBJECT_BY_VALUE,
  OrderByValue,
  YN,
  CONST_YN,
} from '../../../common';
import {
  ClearOutQueryParamMapper,
  ReverseQueryParamMapper,
  RouterQueryParamMapper,
} from '@/core';

@Component({
  name: 'DeliveryFounderConsultList',
  components: {
    DeliveryFounderConsultNanudaUserList,
  },
})
export default class DeliveryFounderConsult extends BaseComponent {
  private deliveryFounderConsultSearchDto = new DeliveryFounderConsultListDto();
  private deliveryFounderConsultDto = new DeliveryFounderConsultDto();
  private deliveryFounderConsultListDto: DeliveryFounderConsultDto[] = [];
  private deliveryFounderConsultTotalCount = null;
  private deliveryFounderConsultCreateDto = new DeliveryFounderConsultDto();
  private newLimit = null;
  private paginationCount: PaginationCount[] = [...CONST_PAGINATION_COUNT];
  private newDate = new Date();
  // excel options
  private fields = {
    이름: 'nanudaUser.name',
    연락처: 'nanudaUser.phone',
    비회원명: 'nonUserName',
    비회원연락처: 'nonUserPhone',
    성별: 'nanudaUser.genderInfo.value',
    업체명: 'deliverySpace.companyDistrict.company.nameKr',
    지점명: 'deliverySpace.companyDistrict.nameKr',
    평수: 'deliverySpace.size',
    상담시간: 'availableTime.value',
    신청일: 'createdAt',
    창업경험: 'changUpExpYn',
    신청상태: 'codeManagement.value',
    비고: 'spaceConsultEtc',
  };
  private json_meta = [
    [
      {
        key: 'charset',
        value: 'utf-8',
      },
    ],
  ];

  private statusSelect: CodeManagementDto[] = [];
  private statusB2BSelect: CodeManagementDto[] = [];
  private availableTimesSelect: CodeManagementDto[] = [];
  private companySelect: CompanyDto[] = [];
  private totalPage = 0;
  private delYn: YN[] = [...CONST_YN];
  private genderSelect: GENDER[] = [...CONST_GENDER];

  private pagination = new Pagination();
  private dataLoading = false;

  private adminList: AdminDto[] = [];
  private managerSelect: CompanyUserDto[] = [];
  private companyUserDto = new CompanyUserDto(BaseUser);

  private districtSelect: CompanyDistrictDto[] = [];
  private companyDistrictDto = new CompanyDistrictDto();

  private foodCategorySelect: FoodCategoryDto[] = [];

  private deliverySpaceSelect: DeliverySpaceDto[] = [];
  private deliverySpaceDto = new DeliverySpaceDto();

  private userData = new NanudaUserDto(BaseUser);
  private nanudaUserData = '';

  // get status color
  getStatusColor(status: FOUNDER_CONSULT) {
    return getStatusColor(status);
  }

  getAdmin() {
    AdminService.findForSelect().subscribe(res => {
      if (res) {
        this.adminList = res.data;
      }
    });
  }

  // 상태값
  getFounderConsultCodes() {
    CodeManagementService.findCodesFounderConsultB2B().subscribe(res => {
      this.statusB2BSelect = res.data;
    });

    CodeManagementService.findCodesFounderConsult().subscribe(res => {
      this.statusSelect = res.data;
    });
  }

  changeCompany(event) {
    const companyNo = event.target.value;
    // this.getCompanyUser(companyNo);
    this.getCompanyDistrict(companyNo);
  }

  changeDistrict(event) {
    const districtNo = event.target.value;
    this.getDeliverySpace(districtNo);
  }

  // 업체 사용자
  getCompanyUser(companyNo) {
    this.companyUserDto.companyNo = companyNo;
    CompanyUserService.findForSelect(this.companyUserDto).subscribe(res => {
      if (res) {
        this.managerSelect = res.data;
      }
    });
  }

  // 업체 지점
  getCompanyDistrict(companyNo) {
    this.companyDistrictDto.companyNo = companyNo;
    CompanyDistrictService.findForSelectOption(
      this.companyDistrictDto,
    ).subscribe(res => {
      if (res) {
        this.districtSelect = res.data;
      }
    });
  }

  // 타입
  getDeliverySpace(districtNo) {
    this.deliverySpaceDto.companyDistrictNo = districtNo;
    DeliverySpaceService.findForSelect(this.deliverySpaceDto).subscribe(res => {
      if (res) {
        this.deliverySpaceSelect = res.data;
      }
    });
  }

  // 희망시간대
  getAvailableTimes() {
    CodeManagementService.findAvailableTimes().subscribe(res => {
      this.availableTimesSelect = res.data;
    });
  }

  // 음식 업종
  getFoodCategories() {
    FoodCategoryService.findForSelect().subscribe(res => {
      this.foodCategorySelect = res.data;
    });
  }

  // TODO: Create autocomplete box
  getCompanies() {
    CompanyService.findForSelect().subscribe(res => {
      this.companySelect = res.data;
    });
  }

  paginateSearch() {
    this.findAll(true);
  }

  search() {
    this.findAll(true, true);
  }

  // 검색하기
  findAll(isPagination?: boolean, isSearch?: boolean) {
    this.dataLoading = true;
    this.pagination.limit = this.newLimit;
    if (!isPagination) {
      this.pagination.page = 1;
    } else {
      if (isSearch) this.pagination.page = 1;
      RouterQueryParamMapper(
        this.deliveryFounderConsultSearchDto,
        this.pagination,
      );
    }
    DeliveryFounderConsultService.findAll(
      this.deliveryFounderConsultSearchDto,
      this.pagination,
    ).subscribe(res => {
      if (res) {
        this.dataLoading = false;
        this.deliveryFounderConsultListDto = res.data.items;
        this.deliveryFounderConsultTotalCount = res.data.totalCount;
      }
    });
  }

  // 초기화
  clearOut() {
    if (location.search) {
      ClearOutQueryParamMapper();
    } else {
      this.deliveryFounderConsultSearchDto = new DeliveryFounderConsultListDto();
      this.findAll();
    }
  }

  create() {
    DeliveryFounderConsultService.create(
      this.deliveryFounderConsultCreateDto,
    ).subscribe(res => {
      if (res) {
        this.search();
        toast.success('추가완료');
      }
    });
  }
  clearOutCreateDto() {
    this.deliveryFounderConsultCreateDto = new DeliveryFounderConsultDto();
    this.userData = new NanudaUserDto(BaseUser);
    this.nanudaUserData = '';
  }

  // 사용자 추가
  findUser() {
    this.$root.$emit('find_nanuda_user');
  }

  created() {
    this.newLimit = PaginationCount.TWENTY;
    const query = ReverseQueryParamMapper(location.search);
    if (query) {
      this.deliveryFounderConsultSearchDto = query;
      if (!isNaN(+query.limit) && !isNaN(+query.page)) {
        this.newLimit = +query.limit;
        // this.pagination.limit = +query.limit;
        this.pagination.page = +query.page;
      } else {
        this.pagination = new Pagination();
      }
      this.paginateSearch();
    } else {
      this.findAll();
    }
    this.getAvailableTimes();
    this.getCompanies();
    this.getFounderConsultCodes();
    this.getFoodCategories();
    this.getAdmin();
  }

  mounted() {
    this.$root.$on('select_nanuda_user', user => {
      if (user.no) {
        this.userData = user;
        this.nanudaUserData = `${this.userData.name} - ${this.userData.phone}`;
        this.deliveryFounderConsultCreateDto.nanudaUserNo = user.no;
      }
    });
  }
}
